import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';

const SidebarHref = ({
  title, icon, newLink, route, onClick,
}) => (
  <a
    href={route}
    onClick={onClick}
    target="_blank"
    rel="noopener noreferrer"
    className={window.location.href.includes(route) ? "sidebar__link-active" : ""}
  >
    <li className="sidebar__link">
      {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
      <p className="sidebar__link-title">
        {title}
        {newLink ? <Badge className="sidebar__link-badge"><span>New</span></Badge> : ''}
      </p>
    </li>
  </a>
);

SidebarHref.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  newLink: PropTypes.bool,
  route: PropTypes.string,
  onClick: PropTypes.func,
};

SidebarHref.defaultProps = {
  icon: '',
  newLink: false,
  route: '/',
  onClick: () => {},
};

export default SidebarHref;
